var map = {
	"./2.png": "5wYT",
	"./2en.png": "cboW"
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number or string
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "4raq";


//////////////////
// WEBPACK FOOTER
// ./src/assets/theme/light/desc/02keepAlive/lianxiang ^\.\/2.*\.png$
// module id = 4raq
// module chunks = 0